import ModelProxy, {required, optional} from './proxy';
import Sequence from './sequence';

// import {GENE_SIZES, WILDTYPES} from '../constants';


export class ClinicalIsolate extends ModelProxy {

  static propTypes = {
    uuid: required,
    source: required,
    culture: required,
    seqTemplate: required,
    cloneMethod: optional,
    seqMethod: required
  };

}


export class LabIsolate extends ModelProxy {

  static propTypes = {
    uuid: required,
    parent: required,
    mutationList: required,
    sdm: required,
    passage: required
  };

}


export class SuscResult extends ModelProxy {

  static propTypes = {
    uuid: required,
    method: required,
    drugName: required,
    resultMatch: optional,
    result: optional,
    ic: required,
    foldMatch: optional,
    fold: required
  };

}


export class SuscRC extends ModelProxy {

  static propTypes = {
    uuid: required,
    replicaCap: required,
    rangeLow: optional,
    rangeHigh: optional
  };

}


/*function makeGeneConsensus(gene, sequences) {
  let cons = new Array(GENE_SIZES[gene]);
  const wildtype = WILDTYPES[gene];
  for (const {aaseq, firstAa} of sequences) {
    for (let i = 0; i < aaseq.length; i ++) {
      const aI = i + firstAa - 1;
      const curAa = aaseq[i];
      cons[aI] = cons[aI] || {};
      cons[aI][curAa] = cons[aI][curAa] || 0;
      cons[aI][curAa] ++;
    }
  }
  let result = [];
  let firstAa = 0;
  const mixtures = [];
  for (let i = 0; i < cons.length; i ++) {
    let posAas = cons[i];
    if (!posAas) {
      continue;
    }
    if (firstAa === 0) {
      firstAa = i + 1;
    }
    const refAa = wildtype[i];
    posAas = Object.entries(posAas).sort((a, b) => b[1] - a[1]);
    let prevCount = -1;
    let mostCommons = [];
    for (const [aa, count] of posAas) {
      if (count >= prevCount) {
        mostCommons.push(aa);
        prevCount = count;
      }
      else {
        continue;
      }
    }
    mostCommons = mostCommons.join('');
    if (mostCommons.length > 1) {
      mixtures.push({
        codonPosition: i + firstAa,
        aa: mostCommons
      });
      mostCommons = mostCommons.replace(refAa, '');
    }
    if (mostCommons.length > 1) {
      mostCommons = 'X';
    }
    result.push(mostCommons);
  }
  const aaseq = result.join('');
  return new Sequence({
    gene,
    sequenceType: 'Consensus',
    firstAa: firstAa,
    lastAa: firstAa + aaseq.length - 1,
    mixtures,
    naseq: '',
    aaseq
  });
}*/


export default class Isolate extends ModelProxy {

  static propTypes = {
    uuid: required,
    refUuid: required,
    extraRefUuids: optional,
    patientUuid: required,
    isolateName: required,
    isolateDate: required,
    dateMatch: required,
    isolateType: required,
    host: required,
    species: required,
    gene: required,
    subtype: required,
    authorSubtype: optional,
    clinicalIsolate: optional,
    labIsolate: optional,
    suscRC: optional,
    suscResults: optional,
    sequences: required
    // cloneConsensus: required
  };

  static setClinicalIsolate(self, data) {
    self.props.clinicalIsolate = new ClinicalIsolate(data);
  }

  static setLabIsolate(self, data) {
    self.props.labIsolate = new LabIsolate(data);
  }

  static setSuscRC(self, data) {
    self.props.suscRC = new SuscRC(data);
  }

  static setSuscResults(self, data) {
    self.props.suscResults = data.map(
      susc => susc instanceof SuscResult ? susc : new SuscResult(susc)
    );
  }

  static setSequences(self, seqs) {
    self.props.sequences = seqs.map(seq => (
      seq instanceof Sequence ?
        seq : new Sequence(seq)
    ));
  }

  static setSubtype(self, subtype) {
    self.props.subtype = subtype.replace(/^HIV-2 /, '');
  }

  /* static getCloneConsensus(self) {
    if (!this.getHasCloneConsensus(self)) {
      return null;
    }
    const {gene, sequences} = self.props;
    return makeGeneConsensus(gene, sequences);
  }*/

  static getHasCloneConsensus(self) {
    const {sequences} = self.props;
    return sequences.length > 1;
  }

}



// WEBPACK FOOTER //
// ./src/models/isolate.js